import { useCallback } from 'react';

import { pushGA4EcommerceEvent } from 'Util/GA4Ecommerce';

/**
 * Hook to fire GA4 ecommerce events on the dataLayer. Thin wrapper around
 * `Util/GA4Ecommerce`'s pushGA4EcommerceEvent, shared with non-hook call
 * sites (class components, plain dispatchers) that can't use this hook.
 */
export default function useGA4Ecommerce() {
    const pushEcommerceEvent = useCallback(
        (name, ecommerce = {}) => pushGA4EcommerceEvent(name, ecommerce),
        []
    );

    return { pushEcommerceEvent };
}
